import React, { useState, Fragment } from 'react'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { Expaned, Row, Column } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import './goods-detail.scss'
import Button from '@/components/button/button'
import { layerManage, showLayer } from '@/utils/layer'
import Iconfont from '@/components/iconfont/iconfont'
import { $post } from '@/api'
import $msg from '@/utils/message'
import { useRequest } from 'ahooks'
import { IGoodsDetail } from '@/model/types/goods'
import { Spin } from 'antd'
import { getQiniuImgUrl } from '@/config/qiniu'
import { shopStore } from '@/store/shop'
import classNames from 'classnames'
import { SellRecord } from './modules/sell_record'
import { StockChangeRecord } from './modules/stock_change_record'
import { Modal } from '@/components/dialog/modal'
import { GoodsStatus } from '../../widget/goods-status'
import { PricesBox } from '../../../../components/prices/prices-box/prices-box'
import { intervalPrice, intervalMemberPrice } from '@/utils/goods'
import useSetDataTogether from '@/utils/hooks/useSetDataTogether'
import { EditGoods } from '../edit-goods/edit-goods'
import { goodsModel } from '../edit-goods/modules/model'

interface IProps {
    goodsId: number
    onChange?: () => void
}

export const GoodsDetail: React.FC<IProps> = props => {
    const cls = (...args: string[]) => getBEMCls('goods-detail', ...args)
    const [goodsInfo, setGoodsInfo] = useState<IGoodsDetail>()
    const [isShowPricesBox, setIsShowPricesBox] = useState(false)
    const [spinning, setSpinning] = useState<boolean>(true)

    const setAllData = useSetDataTogether()

    const getGoodsDetail = () => {
        return $post({
            url: '/goods/getsinglegoods',
            params: {
                goods_id: props.goodsId,
            },
        })
            .then(res => {
                setAllData(() => {
                    setGoodsInfo(res)
                    setSpinning(false)
                })
            })
            .catch(e => {
                $msg('error', e.message)
            })
    }

    const deleteGoods = () => {
        $post({
            url: '/goods/deletegoods',
            params: {
                goods_id: props.goodsId,
            },
        })
            .then(() => {
                $msg('success', '删除成功')
                props.onChange && props.onChange()
            })
            .catch(e => {
                $msg('error', e.message)
            })
    }

    useRequest(getGoodsDetail)

    return (
        <BaseDrawer
            isShow
            title="商品详情"
            onClose={() => {
                layerManage.pop()
            }}
        >
            <Column data-height-100p>
                <Spin spinning={spinning} style={{ height: 'calc(100%)', display: 'flex' }} data-center-center></Spin>
                <Expaned data-padding-16 style={{ overflow: 'scroll' }}>
                    {/* 商品标题 */}
                    {goodsInfo && (
                        <div className={cls('goods-info')}>
                            <div className={cls('goods-info', 'avatar')}>
                                <img src={getQiniuImgUrl(goodsInfo.img_url)} alt="" />
                                {goodsInfo.category.id && (
                                    <div className={cls('goods-info', 'tip')}>{goodsInfo.category.name}</div>
                                )}
                            </div>
                            <Row className={cls('goods-info', 'title')}>
                                {!!goodsInfo.goods_package.length && <div className={cls('package')}>套</div>}
                                <div className={classNames(cls('goods-info', 'name'), 'text-popper')}>
                                    {goodsInfo.name}
                                </div>
                                {/* 上下架状态 */}
                                {goodsInfo.status === 0 || goodsInfo.on_mall ? (
                                    <div data-margin-left-10>
                                        {goodsInfo.on_mall && shopStore.shopInfo?.wsc_status === 1 && (
                                            <span>
                                                <Iconfont name="icon2shangjiaweishangcheng" size={20}></Iconfont>
                                            </span>
                                        )}
                                        {goodsInfo.status === 0 && (
                                            <span data-margin-left-5>
                                                <Iconfont name="icon2shangjiashouyintai" size={20}></Iconfont>
                                            </span>
                                        )}
                                    </div>
                                ) : (
                                    <div data-margin-left-10>
                                        <i className="iconfont iconweishangjia1" style={{ color: '#FF0000' }}></i>
                                    </div>
                                )}
                            </Row>
                            <Row data-margin-top-8 data-font-size-14>
                                <div>
                                    <span data-color-999>编码：</span>
                                    <span>{goodsInfo.goods_code ? goodsInfo.goods_code : '-'}</span>
                                </div>
                                <div data-margin-left-16>
                                    <span data-color-999>分组：</span>
                                    <span>{goodsInfo.group.name}</span>
                                </div>
                            </Row>
                            {/* 只有一种计价方式  */}
                            {goodsInfo.pricing_methods.length === 1 ? (
                                goodsInfo.pricing_methods[0].sale_prices.length === 1 ? (
                                    // 单售价不含阶梯价
                                    <Fragment>
                                        <Row data-margin-top-16>
                                            <div className={cls('goods-info', 'price')}>
                                                <div className="">
                                                    <span data-font-size-14>¥</span>
                                                    <span data-font-size-20>
                                                        {goodsInfo.pricing_methods[0].sale_prices[0].sale_price}
                                                    </span>
                                                    <span data-font-size-14 data-font-weight-400>
                                                        /{goodsInfo.pricing_methods[0].sales_unit.name}
                                                    </span>
                                                </div>
                                            </div>
                                            {goodsInfo.pricing_methods[0].member_price.sale_price > 0 && (
                                                <div className={cls('goods-info', 'memberPrice')}>
                                                    <Iconfont name="icon8huiyuanjia-12" size={18}></Iconfont>
                                                    <span data-font-size-14 data-margin-left-5>
                                                        ¥
                                                    </span>
                                                    <span data-font-size-20>
                                                        {goodsInfo.pricing_methods[0].member_price.sale_price}
                                                    </span>
                                                    <span data-font-size-14 data-font-weight-400>
                                                        /{goodsInfo.pricing_methods[0].sales_unit.name}
                                                    </span>
                                                </div>
                                            )}
                                        </Row>
                                        {/* 计价说明 */}
                                        <Row data-font-size-14 data-color-999 data-margin-top-5>
                                            {goodsInfo.pricing_methods[0].sales_unit_ratio > 1 && (
                                                // tslint:disable-next-line:max-line-length
                                                <div>
                                                    一{goodsInfo.stock_unit.name}=
                                                    {goodsInfo.pricing_methods[0].sales_unit_ratio}
                                                    {goodsInfo.pricing_methods[0].sales_unit.name}
                                                </div>
                                            )}
                                            <div data-margin-left-10>
                                                {goodsInfo.pricing_methods[0].price_annotation}
                                            </div>
                                        </Row>
                                    </Fragment>
                                ) : (
                                    // 含阶梯价
                                    <Fragment>
                                        <Row
                                            data-margin-top-16
                                            className={cls('goods-info', 'hover')}
                                            onClick={() => setIsShowPricesBox(!isShowPricesBox)}
                                        >
                                            <div className={classNames(cls('goods-info', 'price'))}>
                                                <div className="">
                                                    <span data-font-size-14>¥</span>
                                                    <span data-font-size-20>
                                                        {intervalPrice(goodsInfo.pricing_methods).min}~
                                                        {intervalPrice(goodsInfo.pricing_methods).max}
                                                    </span>
                                                </div>
                                            </div>
                                            {goodsInfo.pricing_methods[0].member_price.sale_price > 0 && (
                                                <div className={cls('goods-info', 'memberPrice')}>
                                                    <Iconfont name="icon8huiyuanjia-12" size={18}></Iconfont>
                                                    <span data-font-size-14 data-margin-left-5>
                                                        ¥
                                                    </span>
                                                    <span data-font-size-20>
                                                        {goodsInfo.pricing_methods[0].member_price.sale_price}
                                                    </span>
                                                </div>
                                            )}
                                            <Row data-margin-left-5 data-align-items-center>
                                                <Iconfont
                                                    name={isShowPricesBox ? 'icon6xiala2-20-copy' : 'icon6xiala2-20'}
                                                    size={16}
                                                ></Iconfont>
                                            </Row>
                                        </Row>
                                    </Fragment>
                                )
                            ) : (
                                <Fragment>
                                    <Row
                                        data-margin-top-16
                                        className={cls('goods-info', 'hover')}
                                        onClick={() => setIsShowPricesBox(!isShowPricesBox)}
                                    >
                                        <div className={classNames(cls('goods-info', 'price'))}>
                                            <div className="">
                                                <span data-font-size-14>¥</span>
                                                <span data-font-size-20>
                                                    {intervalPrice(goodsInfo.pricing_methods).min}~
                                                    {intervalPrice(goodsInfo.pricing_methods).max}
                                                </span>
                                            </div>
                                        </div>
                                        {intervalMemberPrice(goodsInfo.pricing_methods).length > 0 && (
                                            <div className={cls('goods-info', 'memberPrice')}>
                                                <Iconfont name="icon8huiyuanjia-12" size={18}></Iconfont>
                                                <span data-font-size-14 data-margin-left-5>
                                                    ¥
                                                </span>
                                                <span data-font-size-20>
                                                    {intervalMemberPrice(goodsInfo.pricing_methods).min}~
                                                    {intervalMemberPrice(goodsInfo.pricing_methods).max}
                                                </span>
                                            </div>
                                        )}
                                        <Row data-margin-left-5 data-align-items-center>
                                            <Iconfont
                                                name={isShowPricesBox ? 'icon6xiala2-20-copy' : 'icon6xiala2-20'}
                                                size={16}
                                            ></Iconfont>
                                        </Row>
                                    </Row>
                                </Fragment>
                            )}
                            {/*多种计价方式 */}
                            {isShowPricesBox && (
                                <PricesBox pricing_methods={goodsInfo.pricing_methods} goods={goodsInfo}></PricesBox>
                            )}
                        </div>
                    )}
                    {/* 库存信息 */}
                    <Row className={cls('sell-info')}>
                        <div className={cls('sell-info', 'stock')}>
                            <div data-font-weight-600 data-font-size-20>
                                {goodsInfo?.stock}
                            </div>
                            <div data-margin-top-10 data-font-size-12 data-color-999>
                                库存剩余
                            </div>
                        </div>
                        <Expaned className={cls('sell-info', 'sell')}>
                            <Row data-center>
                                <Expaned data-column-center-center>
                                    <div>
                                        <span data-font-size-20 data-font-weight-600>
                                            {goodsInfo?.amount_sold_today}
                                        </span>
                                        <span data-font-weight-600>/{goodsInfo?.amount_sold}</span>
                                    </div>
                                    <div data-margin-top-10 data-font-size-12 data-color-999>
                                        今日销量/总销量
                                    </div>
                                </Expaned>
                                <Expaned data-column-center-center>
                                    <div>
                                        <span data-font-size-20 data-font-weight-600>
                                            {goodsInfo?.money_sold_today}
                                        </span>
                                        <span data-font-weight-600>
                                            /<i data-font-size-12>¥</i>
                                            {goodsInfo?.money_sold}
                                        </span>
                                    </div>
                                    <div data-margin-top-10 data-font-size-12 data-color-999>
                                        今日销售额/总销售额
                                    </div>
                                </Expaned>
                            </Row>
                        </Expaned>
                    </Row>
                    <Row className={cls('title')}>
                        <span className={cls('title', 'line')}></span>
                        <span data-font-size-14 data-font-weight-600>
                            近期销售记录
                        </span>
                    </Row>
                    <SellRecord goodsId={props.goodsId}></SellRecord>
                    <Row className={cls('title')}>
                        <span className={cls('title', 'line')}></span>
                        <span data-font-size-14 data-font-weight-600>
                            近期库存变更
                        </span>
                    </Row>
                    <div
                        style={{
                            marginBottom: '60px',
                        }}
                    >
                        <StockChangeRecord goodsId={props.goodsId} />
                    </div>

                    {/* 
                    <div className={cls('line')}></div>
                    <Row data-height-60 data-align-items-center>
                        <Iconfont name="icon6sousuo333-20" size={20}></Iconfont>
                        <div data-font-size-14 data-font-weight-600 data-color-000 data-margin-left-5>
                            记录查询
                        </div>
                    </Row>

                    <Row
                        style={{
                            marginBottom: '60px',
                        }}
                    >
                        <div className={cls('record-item')}>
                            <div data-font-size-14 data-font-weight-600 data-color-000>
                                销售记录
                            </div>
                            <div data-font-size-14 data-color-999>
                                322条
                            </div>
                        </div>
                        <div className={cls('record-item')}>
                            <div data-font-size-14 data-font-weight-600 data-color-000>
                                库存变更
                            </div>
                            <div data-font-size-14 data-color-999>
                                322条
                            </div>
                        </div>
                    </Row> */}
                </Expaned>
                {goodsInfo && (
                    <Row data-height-70 data-align-items-center className={cls('footer')}>
                        <Expaned className={cls('footer', 'left')}>
                            <span data-color-999 data-font-size-14 data-margin-right-5>
                                上架状态:
                            </span>
                            <GoodsStatus type="mall" goodsList={[goodsInfo]} onChange={() => getGoodsDetail()} />
                            <GoodsStatus
                                styles={{ marginLeft: '10px' }}
                                type="cashier"
                                goodsList={[goodsInfo]}
                                onChange={() => getGoodsDetail()}
                            />
                        </Expaned>
                        <Row className={cls('footer', 'right')}>
                            <Button
                                types="text"
                                onClick={() => {
                                    showLayer(
                                        <Modal
                                            isShow={true}
                                            type="danger"
                                            onClose={() => layerManage.pop()}
                                            onCancel={() => layerManage.pop()}
                                            onConfirm={() => {
                                                layerManage.popAll()
                                                deleteGoods()
                                            }}
                                        >
                                            <div data-margin-top-16 data-margin-bottom-24>
                                                <div data-color-000 data-font-weight-600 data-font-size-20>
                                                    确认删除商品{' '}
                                                    <span data-color-danger>{goodsInfo && goodsInfo.name}</span> 吗？
                                                </div>
                                                <div data-font-size-14 data-color-999 data-margin-top-8>
                                                    删除商品后，仍会保留其相关销售数据
                                                </div>
                                            </div>
                                        </Modal>,
                                    )
                                }}
                            >
                                删除
                            </Button>
                            <Button
                                types="primary"
                                data-margin-left-10
                                onClick={() => {
                                    layerManage.pop()
                                    showLayer(<EditGoods goodsModel={goodsModel} mode="edit" goodsId={props.goodsId} />)
                                }}
                            >
                                编辑
                            </Button>
                        </Row>
                    </Row>
                )}
            </Column>
        </BaseDrawer>
    )
}
